import Handler from "../Handler";
class RITAcceptHandler extends Handler {
    execute(message) {
      let receivedData = JSON.parse(message);
      this.service.processRITAccept(receivedData);
    }
  }
  
  export default RITAcceptHandler;